const BASE = "/";
const SIGN_GENERATOR = `${BASE}sign-generator`;
const NEW_POSITION = `${BASE}new-position`;
const EDIT_POSITION = `${BASE}edit-position/:id`;

const LOGIN = `${BASE}login`;

export { BASE, SIGN_GENERATOR, NEW_POSITION, EDIT_POSITION, LOGIN };
